export default {
    lang: {
        name: 'Date'
    }
}